// Generated by ts-to-zod
import { z } from 'zod';
import { userSchema } from '../../users/models/user.schema';

export const patchUserPayloadSchema = userSchema.partial();
